module.exports = __webpack_public_path__ + "c97cadd36641e9b80ee468cace26b355.ttf";